import type { ConnectorSummary } from "@/types/connectors.ts";

type TourConnector = Pick<ConnectorSummary, "supportsEmail" | "supportsCalendar" | "missingAccess">;

/**
 * Which welcome-tour lines promise access the account does not have.
 *
 * Hidden only on evidence: an account with no connector at all (a phone
 * sign-up), or a sign-in connector whose `missingAccess` names the access while
 * no connector holds it. A row with nothing on record reports no email or
 * calendar flag but lacks nothing, and a server that predates `missingAccess`
 * says nothing, so both keep the lines. Until the user loads, nothing hides.
 */
export function tourHidesAccess(connectors: readonly TourConnector[] | undefined): {
  inbox: boolean;
  calendar: boolean;
} {
  if (!connectors) return { inbox: false, calendar: false };
  if (connectors.length === 0) return { inbox: true, calendar: true };
  const lacks = (access: "email" | "calendar", holds: (c: TourConnector) => boolean) =>
    !connectors.some(holds) &&
    connectors.some((connector) => connector.missingAccess?.includes(access) === true);
  return {
    inbox: lacks("email", (c) => c.supportsEmail),
    calendar: lacks("calendar", (c) => c.supportsCalendar),
  };
}
